import Vue from 'vue'
import Router from 'vue-router'
import axios from "axios";


// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');
const Logout = () => import('@/views/pages/Logout');

// Users
const UserOverview = () => import('@/views/users/Overview');
const UserList = () => import('@/views/users/List');
const UserAdd = () => import('@/views/users/Add');
const UserEdit = () => import('@/views/users/Edit');


// Admin
const AdminList = () => import('@/views/admin/List');
const AdminAdd = () => import('@/views/admin/Add');
const AdminEdit = () => import('@/views/admin/Edit');

//setting
const overview = () => import('@/views/settings/overview');

//Stock
const StockList = () => import("@/views/stocks/List");
const StockDetail = () => import("@/views/stocks/Detail");

//Logs
const LogList = () => import("@/views/logs/List");


Vue.use(Router);

let router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Bảng điều khiển',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Bảng tin',
          component: Dashboard
        },
        {
          path: 'users',
          meta: {label: 'Thành viên'},
          name: "Tài khoản",
          redirect: '/users/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'overview',
              meta: {label: 'Tổng quan'},
              component: UserOverview,
            },
            {
              path: 'list',
              meta: {label: 'Tất cả'},
              component: UserList,
            },
            {
              path: 'new',
              meta: {label: 'Thêm mới'},
              component: UserAdd,
            },
            {
              path: ':id',
              meta: {label: 'Chỉnh sửa'},
              component: UserEdit,
            },
          ]
        },

        {
          path: '/stock',
          redirect: '/stock',
          name: 'Cổ phiếu',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: 'Tất cả',
              component: StockList
            },
            {
              path: ':id',
              name: 'Chi tiết',
              component: StockDetail
            }
          ]
        },

        {
          path: 'admin',
          meta: {label: 'Quản trị'},
          name: "Quản trị",
          redirect: '/admin/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              meta: {label: 'Tất cả'},
              component: AdminList,
            },
            {
              path: 'new',
              meta: {label: 'Thêm mới'},
              component: AdminAdd,
            },
            {
              path: ':id',
              meta: {label: 'Chỉnh sửa'},
              component: AdminEdit,
            },

          ]
        },

        {
          path: '/logs',
          redirect: '/logs',
          name: 'Logs',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: 'Tất cả',
              component: LogList
            },
          ]

        },

        {
          path: '/settings',
          redirect: '/settings/overview',
          name: 'Cài đặt',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'overview',
              name: 'Tổng quan',
              component: overview
            },

          ]
        }

      ]
    },
    {
      path: '',
      redirect: '/login',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'logout',
          name: 'Logout',
          component: Logout
        }
      ]
    }

  ]
})

async function checkAuth(token) {
  try {
    const {data} = await axios.get(this.$configs.api + '/api/v4/cp/admin/auth', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (data) {
      console.log(data)
      return true;
    } else {
      return false
    }

  } catch (err) {
    return false;
  } finally {
    //TODO: if need
  }

}

router.beforeEach(async (to, from, next) => {
  let user = Vue.$cookies.get('user')

  if (to.name !== "Login") {
    if (!user) {
      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      });
      Vue.prototype.$userLogged = typeof user=== 'object' ? user: JSON.parse(user);
      next();
    }

    Vue.prototype.$userLogged = typeof user=== 'object' ? user: JSON.parse(user);
    next();

  } else {
    if (user) {
      Vue.prototype.$userLogged = typeof user=== 'object' ? user: JSON.parse(user);
      next({
        path: '/dashboard',
        params: {nextUrl: to.fullPath}
      });
    } else {
      next();
    }
  }
});

export default router;
